/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SettingBuyingHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.SettingBuyingHistoryPage
);
